import BaseMessage from './base-message';

/**
 *
 * @module StateEventMessage
 * @desc Message containing a type and event object
 * @class StateEventMessage
 *
 */
class StateEventMessage extends BaseMessage {

    /**
     *
     * @param {string} type
     * @param {Event} event s
     * @constructor
     *
     */
    constructor(type, event, stateModel) {

        super(type);

        /**
         *
         * @desc {Event}
         *
         */
        this.event = event;

        /**
         *
         * @desc the model representing the current player state
         *
         */
        this.stateModel = stateModel;

    }

}

StateEventMessage.PLAYER_STATE_UPDATE = 'PLAYER_STATE_UPDATE';
StateEventMessage.PLAYER_TIME_STATE_UPDATE = 'PLAYER_TIME_STATE_UPDATE';

export default StateEventMessage;
